const websocketConfig = {
  // address: 'ws://score11.de:8080'
  address: "wss://buzzer.yourserver.de:23231"
  // address: 'ws://localhost:8080'
};

export default websocketConfig;



// WEBPACK FOOTER //
// ./src/config/websocket.js